import _ from 'lodash'
import * as AddTypes from 'scoreboard/components/add-types'
const { CHILD, SIBLING, ROOT } = AddTypes
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * For sections that have folders, determines whether new items should be
 * added as siblings or children.
 *
 * The rules are (from #7476), listed in order of priority:
 * 1) If the new item is a folder, it should be a sibling of the selected item
 * 2) If the selected item is a folder, the new item is a child.
 * 3) If the selected item is a report, dashboard, or document, the new item is
 * a sibling
 *
 * @param relative
 *            the tree node attributes representing the relative item
 * @param newItem
 *            the model of the new item being added
 * @return CHILD or SIBLING or ROOT
 */
function newFolderAddType(relative, newItem) {
	relative = unwrapModel(relative)
	newItem = unwrapModel(newItem)
	//if the parent is replicated, always send a new non-replicated item to the bottom of the root level #19293
	if (!_.isNil(_.get(relative, 'syncId'))) {
		return ROOT
	}

	// rule 1
	if (newItem.type === 'folder') {
		return SIBLING
	}
	// rule 2
	if (relative.type === 'folder') {
		return CHILD
	}
	// rule 3
	return SIBLING
}

export default newFolderAddType
export { CHILD }
export { SIBLING }
export { ROOT }
newFolderAddType.__filename__ = 'components/new-folder-add-type.js'
